var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platelet model shadow-1 b-r-1 m-b-5"},[_c('b-skeleton',{attrs:{"width":"60%"}}),_c('b-skeleton',{attrs:{"width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }